<!-- header title and station selection -->
<div>
	<h1>{{templateID}}</h1>
</div>
<div style="float:left">
	<h3>Station {{stationID}} Dashboard</h3>
</div>

<div id="stationListAndInfo" [ngClass]="{doNotDisplay:!headerVisible}">

<!-- station select list -->
<div class="col-md-8 form-group" style="float:left; padding-left:10px; padding-top: 15px" id="selDiv">
	<p-select [options]="stationList" [(ngModel)]="listSelection" [style]="{'width':'80%'}" 
		(ngModelChange)="newStationSelected($event)" [filter]="true"
		placeholder="Select a station">
		<ng-template let-station pTemplate="item">
			<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
            			<div class="{{station.novaScoreClass}} stationListElement">{{station.label}}</div>
        		</div>
		</ng-template>
	</p-select>

	<!-- hamburger download button-->
    <p-menu #menu [popup]="true" [model]="dataAccessOptions" appendTo="body" class="spaceLeft"></p-menu>
    <button id='dataAccessButton' type="button" pButton icon="pi pi-bars" (click)="menu.toggle($event)"></button>
</div>

<!-- general station information -->
<div style="clear:both"></div>  <!-- puts items in following div on new lines -->
<div class="flex-container">
	<!-- station information including novascore colored data types -->
	<div id="StationInformation">
  		Station name: {{currentStation.stationName}}<br>
  		Station elevation: {{currentStation.stationElevation}}
  		<li *ngFor="let novascore of stationNovaScores">
  			<span class={{novascore.novaScoreClass}}>{{novascore.dataType}} - {{novascore.novaScoreDescription}}</span>
  		</li>
	</div>
	<!-- map -->
	<div id="mapid" class="flex-map" [ngClass]="{doNotDisplay:!mapVisible}"></div>
	<!-- station images -->
	<div id="imagesDiv" class="flex-images" *ngIf="images.length > 0">
		<lib-image-viewer [images]="images" [header]="currentStation.stationName"></lib-image-viewer>
	</div>
</div>

<!-- period of record selection box -->
<div style="clear:both"></div>
 <div class="col-md-6" style="float:left" class="spaceLeft spaceBelow">
	<label class="spaceRight">Period of record:</label>
	 <p-select [options]="periodOfRecordList"
	 	[scrollHeight]="'250px'"
		 [(ngModel)]='periodOfRecordSelected'
		 (ngModelChange)='newPeriodOfRecordSelected($event)' >
	 </p-select>
	 <span *ngIf="periodOfRecordSelected=='0'">
		 	<span class="spaceLeft"> Start date: </span>
			<p-datepicker [(ngModel)]="startDate" dateFormat="yy-mm-dd" showTime="true" hourFormat="24" showIcon="true"></p-datepicker>
		 	<span class="spaceLeft"> End date: </span>
			<p-datepicker [(ngModel)]="endDate" dateFormat="yy-mm-dd" showTime="true" hourFormat="24" showIcon="true"></p-datepicker>
			<button pButton type="button" label="Show Data" title="Update Charts" class="spaceLeft" (click)="newPeriodOfRecordSelected('0')"></button>
	 </span>

	<div class="spaceTop">
	<label class="spaceRight">Tracker:</label>
	<p-select [options]="trackerOptions"
		[(ngModel)]='tooltipPreference'
		(onChange)='tooltipPreferenceChanged($event)' >
	</p-select>
	</div>

 </div>

</div>

<div style="clear:both"></div>


<!-- time series charts -->
<div style="clear:both"></div>  <!-- puts items in following div on new lines -->
<div id="chartContainer" class="row stationsClass">
	
</div>
